import "./restaurant-menu-folders.styles.scss";
const RMFolders = ({ folders, moveBackFolder }) => {
  return (
    <div className="rm-folders-container">
      <span
        onClick={() => moveBackFolder("Main Menu", -1)}
        className="rm-folders-link"
      >
        Main Menu&nbsp;/&nbsp;
      </span>
      {folders.map((folder, index) => {
        return (
          <span
            key={index}
            onClick={() => {
              moveBackFolder(folder, index);
            }}
            className="rm-folders-link"
          >
            {folder}&nbsp;/&nbsp;
          </span>
        );
      })}
    </div>
  );
};
export default RMFolders;
